var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-contaienr"},[_c('VideoBox',{staticClass:"video-box",style:(_vm.videoStyl),attrs:{"videoUrl":_vm.receiveProps.tempData.specialData.bannerVideoUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }